import { gql } from "@apollo/client";

export const confListElementFragment = gql`
  fragment ConfListElementFragment on FraudConfElement {
    code
    name
    disabled
  }
`;
